import * as React from "react";
import { Link, graphql, StaticQuery } from "gatsby";

import logo from "../img/logo/hcs-text-logo-white.svg";
import SocialIcons from "./SocialIcons";

const FooterTemplate = class extends React.Component {
  render() {
    const { data } = this.props;

    const social = data.markdownRemark.frontmatter.social;
    const hcsMenu = data.markdownRemark.frontmatter.navigation.hcsMenu;
    const lowerMenu = data.markdownRemark.frontmatter.navigation.lowerMenu;
    const lowerMenuTrails =
      data.markdownRemark.frontmatter.navigation.lowerMenuTrails;
    const riverMenu =
      data.markdownRemark.frontmatter.navigation.riverShuttlesMenu;
    const gatsbyConfig = data.site.siteMetadata;
    const siteConfig = data.markdownRemark.frontmatter.site;

    const phonenumber = siteConfig.phone;

    let name = null;

    siteConfig.name ? (name = siteConfig.name) : (name = gatsbyConfig.title);

    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content has-text-centered">
          <Link to="/" title={`${name}`}>
            <img src={logo} alt={name} style={{ height: "12em" }} />
          </Link>
        </div>
        <div className="content has-text-centered has-background-black has-text-white-ter">
          <div className="container has-background-black has-text-white-ter">
            <div style={{ maxWidth: "100vw" }} className="columns">
              <div className="column is-3">
                <section className="menu">
                  <h6 className="c-inh">
                    <Link to="/" title={`${name}`} className="c-inh">
                      {`${name}`}
                    </Link>
                  </h6>
                  <ul className="menu-list">
                    {hcsMenu.map((element) => {
                      return (
                        <li key={`${element.name}_lowernav`}>
                          <Link
                            className="navbar-item"
                            to={element.slug}
                            title={element.name}
                            key={`${element.name}_lowernavLink`}
                          >
                            {element.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </section>
              </div>
              <div className="column is-3">
                <section>
                  <Link
                    to="/mtb-shuttles"
                    title="Mountain Bike Trails in Moab, Utah"
                    className="c-inh"
                  >
                    <h6 className="c-inh">
                      Mountain Bike Trails in Moab, Utah
                    </h6>
                  </Link>
                  <ul className="menu-list">
                    {lowerMenuTrails.map((element) => {
                      return (
                        <li key={`${element.name}_lowernavTrail`}>
                          <Link
                            className="navbar-item"
                            to={element.slug}
                            title={element.name}
                            key={`${element.name}_lowernavTrailLink`}
                          >
                            {element.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </section>
              </div>
              <div className="column is-3">
                <section className="menu">
                  {riverMenu && riverMenu.length ? (
                    <>
                      <h6 className="c-inh">
                        <Link
                          to="/river-shuttles/"
                          title="Moab River Shuttle"
                          className="c-inh"
                        >
                          River Shuttles in
                          <br />
                          Moab, Utah
                        </Link>
                      </h6>

                      <ul className="menu-list">
                        {riverMenu.map((element) => {
                          return (
                            <li key={`${element.name}_lowernav`}>
                              <Link
                                className="navbar-item"
                                to={element.slug}
                                title={element.name}
                                key={`${element.name}_lowernavLink`}
                              >
                                {element.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  ) : null}

                  {lowerMenu && lowerMenu.length ? (
                    <>
                      <h6 className="c-inh">
                        <Link
                          to="/"
                          title="Moab Bike Shuttle"
                          className="c-inh"
                        >
                          Riding in Moab, Utah
                        </Link>
                      </h6>
                      <ul className="menu-list">
                        {lowerMenu.map((element) => {
                          return (
                            <li key={`${element.name}_lowernav`}>
                              <Link
                                className="navbar-item"
                                to={element.slug}
                                title={element.name}
                                key={`${element.name}_lowernavLink`}
                              >
                                {element.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  ) : null}
                </section>
              </div>

              <div className="column is-3">
                <section>
                  <h6 className="c-inh">Working Days/Hours</h6>
                  <ul className="no-bullets">
                    <li>MON - SUN / 6AM - 6PM</li>
                    <li>
                      TELEPHONE:{" "}
                      <a
                        href={`tel:+1${phonenumber}`}
                        className="c-inh"
                        title={`Call ${name} Now!`}
                      >
                        {phonenumber}
                      </a>
                    </li>
                    <li>
                      <img
                        src="/uploads/2019/09/icon_credit_cards_small_02.png"
                        alt="All Major Credit Cards Accepted"
                        className="pt-4"
                      />
                    </li>
                  </ul>{" "}
                  <br />
                  <h6 className="c-inh" style={{ marginBottom: "-.5em" }}>
                    Follow
                    <br />
                    Hazard County Shuttle
                  </h6>
                  <SocialIcons
                    socialclassName=""
                    facebook={social.facebook}
                    twitter={social.twitter}
                    instagram={social.instagram}
                    google={social.google}
                    youtube={social.youtube}
                  />
                </section>
              </div>
            </div>
          </div>

          <div className="container">
            <div style={{ maxWidth: "100vw" }} className="columns">
              <div className="column is-9 has-text-left pl-2 ml-2">
                <img
                  src="/uploads/2020/04/van_footer_02-300x129.png"
                  className="footer-van"
                  alt="Moab Bike Shuttle"
                />
                <br /> &copy; Copyright 2019-{new Date().getFullYear()}{" "}
                <Link to="/" title="Hazard County Shuttle" className="c-inh">
                  Hazard County Shuttle
                </Link>
                . All Rights Reserved.{" "}
                <span className="has-text-grey">
                  <Link
                    to="/site-map"
                    title="Site Map"
                    className="has-text-grey"
                  >
                    Site Map
                  </Link>
                </span>
              </div>
              <div className="column is-3 has-text-right pr-2 mr-2">
                <a
                  href="https://lnt.org/"
                  rel="noopener noreferrer nofollow"
                  target="_lnt"
                  title="Leave No Trace"
                >
                  <img
                    src="/uploads/2020/04/lnt_05.png"
                    className="footer-lnt mr-2 pr-2"
                    alt="Leave No Trace"
                  />
                </a>
              </div>
            </div>
            <hr className="gradient" />
            <h2 className="is-size-6 has-text-grey">
              Hazard County Shuttle provides{" "}
              <Link
                to="/book-shuttle"
                title="Moab bike shuttle"
                className="c-inh"
              >
                Moab bike shuttle
              </Link>{" "}
              services in the greater Moab, Utah area. We also offer{" "}
              <a
                title="mountain bike shuttles"
                className="c-inh"
                href="https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/ZdmYD"
              >
                mtb shuttles
              </a>
              ,{" "}
              <a
                title="guided mountain bike tours"
                className="c-inh"
                href="https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/emwRr--4626f750-f448-40ea-9647-d0465b73e392"
              >
                guided mountain bike tours
              </a>
              , and{" "}
              <a
                title="river vehicle transfers"
                className="c-inh"
                href="https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/pxZdA"
              >
                river vehicle transfers
              </a>
              .
            </h2>
          </div>
          <div className="footer-lower float-image-right "></div>
        </div>
      </footer>
    );
  }
};

//export default Footer;

export default function Footer() {
  return (
    <StaticQuery
      query={graphql`
        query LowerNav {
          site {
            siteMetadata {
              title
            }
          }
          markdownRemark(
            frontmatter: { templateKey: { eq: "configuration" } }
          ) {
            frontmatter {
              site {
                name
                url
                phone
              }
              navigation {
                hcsMenu {
                  slug
                  name: title
                }
                lowerMenu {
                  slug
                  name: title
                }
                lowerMenuTrails {
                  slug
                  name: title
                }
                riverShuttlesMenu {
                  slug
                  name: title
                }
              }
              social {
                facebook
                twitter
                instagram
                youtube
                google
              }
            }
          }
        }
      `}
      render={(data, count) => <FooterTemplate data={data} count={count} />}
    />
  );
}
